import { Capacitor, registerPlugin } from "@capacitor/core";
import { Share } from "@capacitor/share";
import { openWhatsAppChatDirect } from "./whatsapp.helper";

type SharePayload = {
  title?: string | null;
  text?: string | null;
  url?: string | null;
  files?: string[] | null;
  preferWhatsApp?: boolean;
};

type NativeSharePlugin = {
  share(options: SharePayload): Promise<{ completed: boolean }>;
  openWhatsAppChat(options: { phoneNumber: string; message: string }): Promise<{ completed: boolean }>;
};

const NativeShare = registerPlugin<NativeSharePlugin>("NativeShare");

export const openNativeWhatsAppChat = async (phoneNumber: string, message: string) => {
  if (Capacitor.isPluginAvailable("NativeShare")) {
    try {
      return await NativeShare.openWhatsAppChat({ phoneNumber, message });
    } catch (error) {
      // Older app installations may have the plugin without this method.
      const code = (error as { code?: string } | null)?.code;
      if (code !== "UNIMPLEMENTED" && code !== "UNAVAILABLE") throw error;
    }
  }

  openWhatsAppChatDirect(phoneNumber, message);
  return { completed: true };
};

export const shareViaNative = async (options: SharePayload) => {
  if (Capacitor.isNativePlatform()) {
    if ((options.files?.length ?? 0) > 0 || options.preferWhatsApp) {
      await NativeShare.share({
        title: options.title ?? undefined,
        text: options.text ?? undefined,
        url: options.url ?? undefined,
        files: options.files ?? undefined,
        preferWhatsApp: options.preferWhatsApp ?? false,
      });
      return;
    }

    await Share.share({
      title: options.title ?? undefined,
      text: options.text ?? undefined,
      url: options.url ?? undefined,
      dialogTitle: options.title ?? undefined,
    });
    return;
  }

  if (navigator.share) {
    await navigator.share({
      title: options.title ?? undefined,
      text: options.text ?? undefined,
      url: options.url ?? undefined,
    });
    return true;
  }

  throw new Error("Share API not supported on this device.");
};
